<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
            v-on="on"
            depressed
            :color="color"
            :dark="isDark"
            :outlined="isOutline"
            :class="style"
            :disabled="disabled"
            :icon="icon"
            @click="$emit('click')">
          <slot/>
        </v-btn>
      </template>
      {{ mensagemTooltip }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
    name: 'botaoAcaoTooltip',
    props: {
        active: {
            type: Boolean,
            default: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        hideBorder: {
            type: Boolean,
            default: false
        },
        cssClass: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon:{
            type: Boolean,
            default: false
        },
        mensagemTooltip:{
            type: String,
            default: null
        }
    },
    computed: {
        color() {
            if (this.active) {
                return 'secondary'
            } else if (this.dark) {
                return ''
            } else {
                return 'primary'
            }
        },
        isDark() {
            return this.dark && !this.active
        },
        isOutline() {
            return !this.active
        },
        style() {
            let styleObj = {
                'call-to-action': true,
                'hide-border': this.hideBorder
            }
            if (this.cssClass) {
                const classes = this.cssClass.split(' ')
                classes.forEach(clazz => (styleObj[clazz] = true))
            }
            return styleObj
        }
    }
}
</script>

<style scoped lang="stylus">
.call-to-action
  font-size 14px
  margin 0
  text-transform none
  position relative
  height unset
  padding 5px 15px
  box-shadow none
  font-weight bold

  i
    margin-right 5px
    font-size 18px

  &.hide-border
    border 0 !important

</style>